@if (!isLoading) {
  @if (notifications.length > 0) {
    <table class="table table-borderless transparent-head mb-0">
      <thead>
      <tr>
        <th class="text-center">Closed</th>
        <th>ID</th>
        <th>Title</th>
        <th class="text-center">Created Date</th>
      </tr>
      </thead>
      <tbody>
      @for (obj of notifications; track obj.notification + '-' + $index) {
        <tr>
          <td class="text-center">
            <app-is-checked [isChecked]="obj.is_closed == 1"></app-is-checked>
          </td>
          <td>
            @if (obj.url) {
              <a [href]="obj.url" [title]="obj.notification" target="_blank" class="clickable text-success">
                <span
                  [tooltipClass]="'large-tooltip'"
                  container="body"
                  [placement]="tooltipPlacement"
                  [ngbTooltip]="showTooltip ? tipContent : null">{{ obj.notification }}</span>
              </a>
            } @else {
              <span
                class="clickable"
                [tooltipClass]="'large-tooltip'"
                container="body"
                [placement]="tooltipPlacement"
                [ngbTooltip]="showTooltip ? tipContent : null"
                (click)="onNotificationModalOpen(obj.notification)">{{ obj.notification }}</span>
            }

            <ng-template #tipContent>
              <div class="text-start">
                <span class="d-block">Notification: {{ obj.notification }}</span>
                <span class="d-block">Tag Names: &nbsp;{{ obj.tags.join(', ') }}</span>
                <span class="d-block mt-2">{{ obj.description }}</span>
              </div>
            </ng-template>
          </td>
          <td>{{ obj.title }}</td>
          <td class="text-center">{{ obj.created_date | niceDate : '.' : true }}</td>
        </tr>
      }
      </tbody>
    </table>
  } @else {
    <nz-alert nzType="info" nzMessage="No notifications!" nzCloseable="true"></nz-alert>
  }
} @else {
  <div class="position-relative nz-spin-h mt-5">
    <nz-spin [nzTip]="'Loading data...'"></nz-spin>
  </div>
}
